import type { Infer } from 'superstruct';
import { array, boolean, object, optional, string } from 'superstruct';

import { adflowApiSchema } from '@adflow/shared/util-route-schema';
import { parsableInteger } from '@adflow/shared/util-superstruct';

import { SalesforceImportPreviewRow } from './salesforce-import-types.dto';

const p = adflowApiSchema.prefix('salesforce-import');

export const SalesforceImportSelectionOptions = object({
	groups: array(string()),
	campaignNames: array(string()),
	tactics: array(string()),
	types: array(string()),
	years: array(string()),
	fixtureModeEnabled: optional(boolean()),
});

export type SalesforceImportSelectionOptions = Infer<
	typeof SalesforceImportSelectionOptions
>;

export const GetSalesforceImportSelectionOptions = p.get('selection-options', {
	req: object({
		query: object({
			startDate: optional(string()),
			endDate: optional(string()),
			onGroup: optional(string()),
			onType: optional(string()),
			onCampaignName: optional(string()),
		}),
	}),
	res: SalesforceImportSelectionOptions,
});

export const SalesforceImportPreviewQuery = object({
	onGroup: string(),
	onCampaignName: string(),
});

export type SalesforceImportPreviewQuery = Infer<
	typeof SalesforceImportPreviewQuery
>;

export const GetSalesforceImportPreview = p.get('preview', {
	req: object({
		query: SalesforceImportPreviewQuery,
	}),
	res: object({
		rows: array(SalesforceImportPreviewRow),
		importableFacebookCount: parsableInteger(),
		importableGoogleCount: parsableInteger(),
	}),
});

export const StartSalesforceImportBody = object({
	onGroup: string(),
	onCampaignName: string(),
	templateIds: optional(array(string())),
});

export type StartSalesforceImportBody = Infer<typeof StartSalesforceImportBody>;

export const StartSalesforceImport = p.post('', {
	req: object({
		body: StartSalesforceImportBody,
	}),
	res: object({
		facebookAmount: parsableInteger(),
		googleAmount: parsableInteger(),
	}),
});

export const SyncSalesforceAccounts = p.post('sync-accounts', {
	req: object({}),
	res: object({}),
});
